import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "google.protobuf";
export interface DoubleValue {
    value: number;
}
export interface FloatValue {
    value: number;
}
export interface Int64Value {
    value: string;
}
export interface UInt64Value {
    value: string;
}
export interface Int32Value {
    value: number;
}
export interface UInt32Value {
    value: number;
}
export interface BoolValue {
    value: boolean;
}
export interface StringValue {
    value: string;
}
export interface BytesValue {
    value: Uint8Array;
}
function createBaseDoubleValue(): DoubleValue {
    return { value: 0 };
}
export const DoubleValue: MessageFns<DoubleValue> = {
    encode(message: DoubleValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== 0) {
            writer.uint32(9).double(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): DoubleValue {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDoubleValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 9) {
                        break;
                    }
                    message.value = reader.double();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<DoubleValue>, I>>(base?: I): DoubleValue {
        return DoubleValue.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<DoubleValue>, I>>(object: I): DoubleValue {
        const message = createBaseDoubleValue();
        message.value = object.value ?? 0;
        return message;
    },
};
function createBaseFloatValue(): FloatValue {
    return { value: 0 };
}
export const FloatValue: MessageFns<FloatValue> = {
    encode(message: FloatValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== 0) {
            writer.uint32(13).float(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): FloatValue {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFloatValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 13) {
                        break;
                    }
                    message.value = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<FloatValue>, I>>(base?: I): FloatValue {
        return FloatValue.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<FloatValue>, I>>(object: I): FloatValue {
        const message = createBaseFloatValue();
        message.value = object.value ?? 0;
        return message;
    },
};
function createBaseInt64Value(): Int64Value {
    return { value: "0" };
}
export const Int64Value: MessageFns<Int64Value> = {
    encode(message: Int64Value, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== "0") {
            writer.uint32(8).int64(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Int64Value {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInt64Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.value = reader.int64().toString();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Int64Value>, I>>(base?: I): Int64Value {
        return Int64Value.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Int64Value>, I>>(object: I): Int64Value {
        const message = createBaseInt64Value();
        message.value = object.value ?? "0";
        return message;
    },
};
function createBaseUInt64Value(): UInt64Value {
    return { value: "0" };
}
export const UInt64Value: MessageFns<UInt64Value> = {
    encode(message: UInt64Value, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== "0") {
            writer.uint32(8).uint64(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): UInt64Value {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUInt64Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.value = reader.uint64().toString();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<UInt64Value>, I>>(base?: I): UInt64Value {
        return UInt64Value.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<UInt64Value>, I>>(object: I): UInt64Value {
        const message = createBaseUInt64Value();
        message.value = object.value ?? "0";
        return message;
    },
};
function createBaseInt32Value(): Int32Value {
    return { value: 0 };
}
export const Int32Value: MessageFns<Int32Value> = {
    encode(message: Int32Value, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== 0) {
            writer.uint32(8).int32(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Int32Value {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInt32Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.value = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Int32Value>, I>>(base?: I): Int32Value {
        return Int32Value.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Int32Value>, I>>(object: I): Int32Value {
        const message = createBaseInt32Value();
        message.value = object.value ?? 0;
        return message;
    },
};
function createBaseUInt32Value(): UInt32Value {
    return { value: 0 };
}
export const UInt32Value: MessageFns<UInt32Value> = {
    encode(message: UInt32Value, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== 0) {
            writer.uint32(8).uint32(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): UInt32Value {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUInt32Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.value = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<UInt32Value>, I>>(base?: I): UInt32Value {
        return UInt32Value.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<UInt32Value>, I>>(object: I): UInt32Value {
        const message = createBaseUInt32Value();
        message.value = object.value ?? 0;
        return message;
    },
};
function createBaseBoolValue(): BoolValue {
    return { value: false };
}
export const BoolValue: MessageFns<BoolValue> = {
    encode(message: BoolValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== false) {
            writer.uint32(8).bool(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): BoolValue {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBoolValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.value = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<BoolValue>, I>>(base?: I): BoolValue {
        return BoolValue.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<BoolValue>, I>>(object: I): BoolValue {
        const message = createBaseBoolValue();
        message.value = object.value ?? false;
        return message;
    },
};
function createBaseStringValue(): StringValue {
    return { value: "" };
}
export const StringValue: MessageFns<StringValue> = {
    encode(message: StringValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): StringValue {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStringValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<StringValue>, I>>(base?: I): StringValue {
        return StringValue.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<StringValue>, I>>(object: I): StringValue {
        const message = createBaseStringValue();
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseBytesValue(): BytesValue {
    return { value: new Uint8Array(0) };
}
export const BytesValue: MessageFns<BytesValue> = {
    encode(message: BytesValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.value.length !== 0) {
            writer.uint32(10).bytes(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): BytesValue {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBytesValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.value = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<BytesValue>, I>>(base?: I): BytesValue {
        return BytesValue.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<BytesValue>, I>>(object: I): BytesValue {
        const message = createBaseBytesValue();
        message.value = object.value ?? new Uint8Array(0);
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
